/**
 * @module experince/product-selector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
import { Component, OnInit, OnDestroy, Input, OnChanges } from '@angular/core';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { LineDeivceDetails } from '@experience/shop/product-selector/interfaces/product-selector.interface';
import { PRODUCT_SELECTOR_CONSTANTS } from '@experience/shop/product-selector/constants/product-selector.constants';
import { FeatureToggleUtilService } from '@support/shared/services/feature-toggle-util.service';
import { Router } from '@angular/router';

@Component({
  selector: 'tmo-byod-device-section',
  templateUrl: './byod-device-section.component.html',
  styleUrls: [],
})
export class ByodDeviceSectionComponent implements OnInit, OnDestroy, OnChanges {
  @Input() public byodDeviceAemContent: ConfigData;
  @Input() public focusedTileIdDetails: LineDeivceDetails;
  @Input() public amount: number;
  /**
   * Holds IMEI data
   */
  public imeiNumber: string;
  /**
   * Holds sku number
   */
  public SKUNumber: string;
  /**
   * Holds sku number
   */
  public simOfferId: string;
  /**
   * Holds sku number
   */
  public simDescription: string;
  /**
   * Holds sku number
   */
  public pricing: string;
  /**
   * Holds Sim number
   */
  public simNumber: string;
  /**
   * Display N/A
   */
  public notApplicableConstant: string;
  /**
   * Holds eid number
   */
  public eid: string;
  public isNewProductSelectorTemplateEnabled: boolean;
  constructor(
    private objectService: ObjectService,
    private featureToggleUtilService: FeatureToggleUtilService,
    private router: Router
  ) {
    this.isNewProductSelectorTemplateEnabled =
      this.featureToggleUtilService.isNewProductSelectorTemplateEnabled();
  }

  /**
   * OnInit method
   * @returns void
   * @memberof ByodDeviceSectionComponent
   */
  public ngOnInit(): void {
    this.updateDeviceSimDetails();
    this.notApplicableConstant = PRODUCT_SELECTOR_CONSTANTS.NA;
  }

  /**
   * Function to update the sim data
   *  @returns void
   * @memberof ByodDeviceSectionComponent
   */
  public ngOnChanges(): void {
    this.updateDeviceSimDetails();
  }

  /**
   * Function used to display Sim, Career make details in PS page
   */
  public updateDeviceSimDetails(): void {
    const simData = this.objectService.get(this.focusedTileIdDetails, 'byodSimData');
    this.imeiNumber = this.objectService.get(this.focusedTileIdDetails, 'byodCMMOrImei.imei')
      ? this.focusedTileIdDetails.byodCMMOrImei.imei
      : PRODUCT_SELECTOR_CONSTANTS.NA;
    this.SKUNumber = this.objectService.get(simData, 'simSKU');
    this.simOfferId = this.objectService.get(simData, 'simOfferId');
    this.simDescription = this.objectService.get(simData, 'simDescription');
    this.pricing = this.objectService.get(simData, 'salesPrice');
    this.simNumber = this.objectService.get(simData, 'simNumber');
    this.eid = this.objectService.get(this.focusedTileIdDetails, 'byodCMMOrImei.eid');
  }

  editByodDevice(): void {
    const isPhoenixByodEnabled = this.featureToggleUtilService.isPhoenixByodEnabled();
    const byodUrl = isPhoenixByodEnabled ? '/bring-your-own-phone' : '/bring-your-own-device';
    if (isPhoenixByodEnabled) {
      sessionStorage.setItem(
        'editByodInfo',
        JSON.stringify({ imei: this.imeiNumber, tileId: this.focusedTileIdDetails?.tileId })
      );
      // navigating outside Angular , hence bypassing Angular router
      window.location.href = window.location.href.replace(this.router.url, byodUrl)
    } else {
      this.router.navigate([byodUrl], {
      queryParams: {
        allowEdit: true,
      },
    });
    }
  }

  /**
   * Unsubscribe from all component data
   *  @returns void
   * @memberof LineDetailsComponent
   */
  public ngOnDestroy(): void {}
}
